/* Pépi Pépi : animations légères (titres mot à mot, apparition des textes et des images, compteur). */
(function () {
  if (window.__ppMotion) return;
  window.__ppMotion = true;
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function split(el) {
    if (el.__ppSplit) return;
    el.__ppSplit = true;
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (t) {
            if (!t) return;
            if (/^\s+$/.test(t)) { frag.appendChild(document.createTextNode(' ')); return; }
            var s = document.createElement('span');
            s.className = 'pp-w';
            s.style.setProperty('--i', i++);
            s.textContent = t;
            frag.appendChild(s);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && n.tagName !== 'BR') {
          walk(n);
        }
      });
    })(el);
  }

  var timers = new WeakMap();
  function count(el, reset) {
    var to = parseFloat(el.getAttribute('data-count'));
    var suffix = el.getAttribute('data-suffix') || '';
    if (isNaN(to)) return;
    if (timers.has(el)) { cancelAnimationFrame(timers.get(el)); timers.delete(el); }
    if (reset) { el.textContent = '0' + suffix; return; }
    if (calm) { el.textContent = to + suffix; return; }
    var dur = 2200, t0 = null;
    function tick(t) {
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(to * e) + suffix;
      if (p < 1) timers.set(el, requestAnimationFrame(tick)); else timers.delete(el);
    }
    timers.set(el, requestAnimationFrame(tick));
  }

  function prepare(root) {
    /* les titres de section qui n'ont pas l'attribut data-split le reçoivent ici : tous les titres se comportent pareil (mots qui apparaissent, mots en jaune animés) */
    (root || document).querySelectorAll('.pm-h, .pr-h, .pcs-h, .pi-heading').forEach(function (h) { if (!h.hasAttribute('data-split')) h.setAttribute('data-split', ''); });
    (root || document).querySelectorAll('[data-split]').forEach(split);
    (root || document).querySelectorAll('[data-stagger]').forEach(function (box) {
      var step = parseInt(box.getAttribute('data-stagger'), 10) || 90;
      Array.prototype.forEach.call(box.children, function (c, i) {
        if (!c.hasAttribute('data-reveal')) c.setAttribute('data-reveal', '');
        c.style.setProperty('--d', (i * step) + 'ms');
      });
    });
  }

  window.ppMotion = { split: split, count: count, prepare: prepare };

  /* apparition douce de tous les textes et images des pages de contenu (hors zones dynamiques : produit, panier, catalogue, en-tête, pied de page) */
  function autoReveal() {
    var main = document.querySelector('main, #MainContent');
    if (!main) return;
    var skip = '[data-reveal], [data-split], [data-manual], .mf-section, .pk, form, dialog, header, footer, nav, [class*="marquee"], slideshow-component, product-information, results-list, cart-items-component, .pc-mod, .pepi-collection-container, .shopify-section[id*="product"], .shopify-section[id*="main-cart"], .shopify-section[id*="main-collection"], .shopify-section[id*="hero"], .shopify-section[id*="announcement"], .shopify-section[id*="header"]';
    var n = 0;
    main.querySelectorAll('p, h2, h3, h4, li, figure, img, blockquote, summary, .pph-pill').forEach(function (el) {
      if (el.closest(skip)) return;
      if (el.tagName === 'IMG') {
        if (el.closest('figure')) return;
        el.setAttribute('data-reveal', 'img');
      } else {
        el.setAttribute('data-reveal', '');
      }
      el.style.setProperty('--d', ((n++ % 4) * 70) + 'ms');
    });
  }

  function init() {
    autoReveal();
    prepare(document);
    var targets = document.querySelectorAll('[data-split], [data-reveal], [data-count]');
    var auto = Array.prototype.filter.call(targets, function (t) { return !t.closest('[data-manual]'); });
    if (calm || !('IntersectionObserver' in window)) {
      auto.forEach(function (t) { t.classList.add('is-in'); if (t.hasAttribute('data-count')) count(t); });
      return;
    }
    auto.forEach(function (t) { if (t.hasAttribute('data-count')) count(t, true); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var t = en.target;
        t.classList.add('is-in');
        if (t.hasAttribute('data-count')) count(t);
        io.unobserve(t);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
    auto.forEach(function (t) { io.observe(t); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
